<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">This novel is dedicated to my beloved husband Scott, to my three sons and to my broader family – all of whom have supported me through the challenges I have faced, and whose love continues to envelop and sustain me.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?6c9aa34c